(function () {
    'use strict';

    angular
        .module('elogbooks.user.sites')
        .controller('UserSitesAssociatesController', UserSitesAssociatesController);

    UserSitesAssociatesController.$inject = [
        'approversResponse',
        'lodash',
        'userManager',
        'quoteThresholdsCollectionResponse',
        'thresholdService',
        'siteAssociatesService',
        'siteResponse',
        'rootResourceResponse',
        '$scope',
        'modulesService'
    ];

    function UserSitesAssociatesController(
        approversResponse,
        lodash,
        userManager,
        quoteThresholdsCollectionResponse,
        thresholdService,
        siteAssociatesService,
        siteResponse,
        rootResourceResponse,
        $scope,
        modulesService
    ) {
        var vm = this;
        vm.approvers = approversResponse;
        vm.canEditAssociates = userManager.hasPermission('SITE_PERMISSION_EDIT_ASSOCIATES');
        vm.canEditApprovers = userManager.hasPermission('SITE_PERMISSION_EDIT_APPROVERS');

        vm.canSeeAssociates = (userManager.hasPermission('site_permission_view_associates') ||
            userManager.hasPermission('user_permission_manage_sites')) &&
            siteResponse.getLink('associates');
        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');

        if (vm.canSeeAssociates) {
            vm.associatesCollectionLoading = true;
            vm.associatesCollection = siteAssociatesService.getSiteAssociates(siteResponse, rootResourceResponse, {limit: 999});
        }

        vm.approverTypes = {
            reactiveJobApprovers: 'REACTIVE_JOB_APPROVERS',
            reactiveJobExtensionsApprovers: 'REACTIVE_JOB_EXTENSIONS_APPROVERS',
            ...(vm.tasksModuleEnabled && {
                plannedJobApprovers: 'PLANNED_JOB_APPROVERS',
                plannedJobExtensionsApprovers: 'PLANNED_JOB_EXTENSIONS_APPROVERS'
            })
        };

        if(vm.quotesModuleEnabled){
            vm.approverTypes.quoteApprovers = 'QUOTE_APPROVERS'
        }

        if (modulesService.isEnabled('surveys_module')) {
            vm.approverTypes.surveyApprovers = 'SURVEY_APPROVERS';
        }

        if (modulesService.isEnabled('contracts_module')) {
            vm.approverTypes.contractApprovers = 'CONTRACT_APPROVERS';
        }

        vm.quoteThresholds = [];

        if (lodash.has(quoteThresholdsCollectionResponse, 'quoteThresholds') ) {
            vm.quoteThresholds = quoteThresholdsCollectionResponse.quoteThresholds;
            thresholdService.initThresholds(vm.quoteThresholds);
            vm.getQuoteApproverThreshold = thresholdService.getQuoteApproverThreshold;
        }

        $scope.$watch('vm.associatesCollection.length', function(newVal, oldVal) {
            if(newVal !== oldVal && newVal !== 0) {
                vm.associatesCollectionLoading = false;
            }
        }, true);
    }
})();
